import cn from 'classnames';
import 'flag-icons/css/flag-icons.min.css';
import { ReactComponent as EmptyFlagIcon } from '../../assets/EmptyLocationFlag.svg';

export type LocationFlagIconProps = {
    locationCode: string | null;
    isSquare?: boolean;
    className?: string;
};

const LocationFlagIcon = ({ locationCode, isSquare, className }: LocationFlagIconProps) => {
    return locationCode ? (
        <div className={cn(`fi fi-${locationCode.toLowerCase()}${isSquare ? ' fis' : ''}`, className)}></div>
    ) : (
        <EmptyFlagIcon width={21} height={18} />
    );
};

export default LocationFlagIcon;
